import { DocumentManagementComponent } from './../document-management/document-management.component';
import { DocumentListService } from './../../services/master-data.service';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { MasterDataService } from '../../services/master-data.service';
import { CommonMessageService } from '../../services/common-message.service';
import { Subscription } from 'rxjs';
import { DocumentModel, DocumentRoleModel, RoleModel, ServiceVerticalModel } from '../document-management/document-management.model';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-document-list',
  templateUrl: './document-list.component.html',
  styleUrls: ['./document-list.component.css']
})
export class DocumentListComponent implements OnInit, OnDestroy {

  @Output() modalChanged = new EventEmitter();

  folderId;
  folderList;
  hideSaveDocumentButton = false;
  docSubscription: Subscription;
  showTable = false;
  userRole;
  userServiceVertical;
  hidePermission = true;
  documentModel: DocumentModel;

  constructor(
    private masterDataService: MasterDataService,
    private commonMessageService: CommonMessageService,
    private modalService: NgbModal,
    private documentListService: DocumentListService,
    private router: Router
  ) {
    console.log('documentlist component constructor');
  }

  ngOnInit(): void {
    this.userRole = localStorage.getItem('userRole');
    this.userServiceVertical = localStorage.getItem('serviceVertical');
    this.loadRole();
    this.loadServiceVertical();
    this.selectedRole = "";
    this.selectedServiceVertical = "";
    this.documentModel = new DocumentModel();

    this.docSubscription = this.documentListService.getDocument().subscribe((docVal: any) => {
      console.log('document..', docVal);
      this.folderList = docVal;
      if (this.folderList != null && this.folderList != undefined) {
        this.mainFolderDocuments(this.folderList.id);
        this.hidePermission = true;
        this.folderList.access.map((res: any) => {
          console.log('userRole', this.userRole, 'access', res.writeAccess);
          if (res.role.name == this.userRole && res.serviceVertical.name == this.userServiceVertical
            && res.writeAccess == false && this.userRole != "Partner") {
            this.hidePermission = false;
          }
        })
      }
    });
  }

  ngOnDestroy() {
    this.docSubscription.unsubscribe();
  }

  deleteRoleRow(index) {
    this.documentModel.access.splice(index, 1);
  }

  onModalClick(documentModalContent) {
    this.openModal(documentModalContent);
    this.hideSaveDocumentButton = false;
  }

  openModal(documentModalContent) {
    let ngbModalOptions: NgbModalOptions = {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
      windowClass: 'animate__animated animate__slideInUp animate__faster',
      backdrop: 'static',
      keyboard: false,
    };
    this.modalService.open(documentModalContent, ngbModalOptions).result.then(
      (result) => {
        // this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  viewDocumentUrl;
  onViewDocumentModalClick(viewDocumentContent, document) {
    let ngbModalOptions: NgbModalOptions = {
      ariaLabelledBy: 'modal-basic-title',
      size: 'xl',
      windowClass: 'animate__animated animate__slideInUp animate__faster',
      backdrop: 'static',
      keyboard: false,
    };
    this.modalService.open(viewDocumentContent, ngbModalOptions).result.then(
      (result) => {
        // this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );

    this.viewDocumentUrl = document.s3location;
    console.log('view document', this.viewDocumentUrl);
  }

  fileList: FileList;
  formData: FormData;
  fileChange(event) {
    this.fileList = event.target.files;
    if (this.fileList.length > 0) {
      let file: File = this.fileList[0];
      this.formData = new FormData();
      this.formData.append('file', file, file.name);
    }
  }

  onSaveButtonClick() {
    console.log('showInputForUrl', this.showInputForUrl);
    if (!this.showInputForUrl) {
      console.log('inside save');
      this.saveDocument();
    } else {
      console.log('inside url');
      this.saveDocumentUrl();
    }
  }

  saveDocument() {
    console.log('save document', this.isDownloadCheck)
    this.masterDataService.addDocument(this.folderList.id, this.formData, this.isDownloadCheck).subscribe((resp: any) => {
      this.closeModel();
      this.commonMessageService.saveMessage();
    });
  }

  saveDocumentUrl() {
    console.log('this.documentUrl', this.documentUrl);
    if (this.documentUrl == "" || this.documentUrl == undefined || this.documentUrlName == "" || this.documentUrlName == undefined) {
      this.commonMessageService.swalAlertWithoutIcon('', 'Please Enter both fields');
      return;
    }
    const formData = new FormData();
    formData.append('url', this.documentUrl);
    formData.append('name', this.documentUrlName);

    this.masterDataService.addDocumentUrl(this.folderList.id, formData).subscribe((resp: any) => {
      this.closeModel();
      this.commonMessageService.saveMessage();
    });
  }


  documentUrl: string;
  documentUrlName: string;
  showInputForUrl: boolean;
  clickCheckBox(event) {
    console.log('checkbox value', event.target.checked);
    if (event.target.checked == true) {
      this.showInputForUrl = true;
    } else {
      this.showInputForUrl = false;
    }
  }

  isDownloadCheck = false;
  downloadCheckBoxClick(event) {
    this.isDownloadCheck = event.target.checked;
    console.log('event', this.isDownloadCheck)
  }


  mainFolderDocumentsList = [];
  mainFolderDocuments(folderId) {
    this.masterDataService.getMainFolderDocuments(folderId).subscribe((resp: any) => {
      this.mainFolderDocumentsList = resp;
      console.log('document list', this.mainFolderDocumentsList);
      console.log('is Mis:', this.folderList.mis)
    });
  }


  editDocumentId;
  editDocumentName;
  editDocumnetURL;
  hideCheckboxOnEdit = true;
  onEditDocument(document, documentModalContent) {
    console.log('formdata value', this.formData);
    this.hideCheckboxOnEdit = false;
    console.log('document', document);
    this.isDownloadCheck = document.viewOnly;
    this.editDocumentName = document.name;
    this.editDocumnetURL = document.s3location;
    this.editDocumentId = document.id;
    this.openModal(documentModalContent);
    this.hideSaveDocumentButton = true;
  }

  onUpdateDocument() {
    console.log('formdata vlue', this.formData);
    if (this.formData == undefined) {
      this.masterDataService.updateViewOnlyDocument(this.editDocumentId, this.formData, this.isDownloadCheck).subscribe((resp: any) => {
        //  this.masterDataService.deleteBucketDocument(this.editDocumentId).subscribe((resp:any)=>{})
        console.log('view resp', resp);
        this.closeModel();
        this.commonMessageService.updateMessage();
      });
    } else {
      this.masterDataService.updateDocument(this.editDocumentId, this.formData, this.isDownloadCheck).subscribe((resp: any) => {
        //  this.masterDataService.deleteBucketDocument(this.editDocumentId).subscribe((resp:any)=>{})
        console.log('resp', resp);
        this.closeModel();
        this.commonMessageService.updateMessage();
      });
    }
  }

  onDeleteDocument(document) {
    Swal.fire({
      text: 'Are you sure you want to remove?',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      confirmButtonColor: '#800000'
    }).then((result) => {
      if (result.isConfirmed) {
        this.masterDataService.deleteDocument(document.id).subscribe((resp: any) => {
          this.commonMessageService.deleteMessage();
          this.mainFolderDocuments(this.folderList.id);
        });
      }
    })
  }

  onDeleteDocumentUrl(document) {
    Swal.fire({
      text: 'Are you sure you want to remove?',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      confirmButtonColor: '#800000'
    }).then((result) => {
      if (result.isConfirmed) {
        this.masterDataService.deleteDocumentUrl(document.id).subscribe((resp: any) => {
          this.commonMessageService.deleteMessage();
          this.mainFolderDocuments(this.folderList.id);
        });
      }
    })
  }

  closeModel() {
    this.modalService.dismissAll();
    this.selectedRole = "";
    this.hideCheckboxOnEdit = true;
    this.showInputForUrl = false;
    this.isDownloadCheck = false;
    this.documentUrl = "";
    this.documentUrlName = ""
    this.editDocumentName = "";
    this.formData = undefined;
    this.mainFolderDocuments(this.folderList.id);
  }

  modalChangeValue(event: { showOpenModal: boolean }) {
    console.log('edit clickevent', event.showOpenModal);
    this.showOpenModal = event.showOpenModal;
    // this.modalChanged.emit({showOpenModal:false});
  }

  showOpenModal = false;
  hideSaveButton = false;
  onEditFolderClick() {
    this.selectedRole = "";
    this.showOpenModal = true;
    this.hideSaveButton = true;
    // this.modalChanged.emit({showOpenModal:false});
  }

  onDeleteFolderClick() {
    this.documentListService.sendFolderIdForDelete(this.folderList.id);
  }

  onAddFolderClick(modalContent) {
    this.documentModel = new DocumentModel();
    this.selectedRole = "";
    this.openFolderModal(modalContent);
  }

  openFolderModal(content) {
    let ngbModalOptions: NgbModalOptions = {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
      windowClass: 'animate__animated animate__slideInUp animate__faster',
      backdrop: 'static',
      keyboard: false,
    };
    this.modalService.open(content, ngbModalOptions).result.then(
      (result) => {
        // this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  roleList;
  loadRole() {
    this.masterDataService.getRoles().subscribe((resp: any) => {
      this.roleList = resp;
      console.log('rolelist', this.roleList);
    });
  }

  serviceVerticalList;
  loadServiceVertical() {
    this.masterDataService.getServiceVerticalList().subscribe((resp: any) => {
      this.serviceVerticalList = resp;
    });
  }

  // selectedRole;
  // afterRoleSelect() {
  //   if (this.selectedRole !== null && this.selectedRole.name === "Article") {
  //     var documentRole = new DocumentRoleModel();
  //     var role = new RoleModel()
  //     role.name = this.selectedRole.name;
  //     role.id = this.selectedRole.id;
  //     documentRole.role = role
  //     this.documentModel.access.push(documentRole);
  //     console.log("documentModel", this.documentModel)
  //   }

  // }

  // selectedServiceVertical;
  // afterServiceVerticalSelect() {
  //   if (this.selectedRole !== null && this.selectedRole !== "Article") {
  //     var documentRole = new DocumentRoleModel();
  //     var role = new RoleModel();
  //     var serviceVertical = new ServiceVerticalModel();
  //     role.name = this.selectedRole.name;
  //     role.id = this.selectedRole.id;
  //     serviceVertical.name = this.selectedServiceVertical.name;
  //     serviceVertical.id = this.selectedServiceVertical.id;
  //     documentRole.role = role
  //     documentRole.serviceVertical = serviceVertical;
  //     this.documentModel.access.push(documentRole);
  //     console.log("documentModel", this.documentModel)
  //   }
  // }

  selectedRole;
  selectedServiceVertical;

  onRoleChange() {
  // Clear service vertical whenever role changes
  this.selectedServiceVertical = null;

  // Remove existing entries for this role
  this.documentModel.access = this.documentModel.access.filter(
    a => a.role?.id !== this.selectedRole?.id
  );

  // Article → add immediately
  if (this.selectedRole?.name === 'Article') {
    const documentRole = new DocumentRoleModel();

    const role = new RoleModel();
    role.id = this.selectedRole.id;
    role.name = this.selectedRole.name;

    documentRole.role = role;
    documentRole.serviceVertical = null;

    this.documentModel.access.push(documentRole);
  }

  console.log('documentModel', this.documentModel);
}

onServiceVerticalChange() {
  // Non-Article → wait until service vertical is selected
  if (!this.selectedRole || this.selectedRole.name === 'Article') {
    return;
  }

  if (!this.selectedServiceVertical) {
    return;
  }

  // Remove existing entry for same role
  this.documentModel.access = this.documentModel.access.filter(
    a => a.role?.id !== this.selectedRole.id
  );

  const documentRole = new DocumentRoleModel();

  const role = new RoleModel();
  role.id = this.selectedRole.id;
  role.name = this.selectedRole.name;

  const serviceVertical = new ServiceVerticalModel();
  serviceVertical.id = this.selectedServiceVertical.id;
  serviceVertical.name = this.selectedServiceVertical.name;

  documentRole.role = role;
  documentRole.serviceVertical = serviceVertical;

  this.documentModel.access.push(documentRole);
  console.log('documentModel', this.documentModel);
}


  onSaveFolderClick() {
    if (this.documentModel.name == "") {
      this.commonMessageService.swalAlertWithoutIcon('', "Please Enter Folder Name");
      return;
    }
    this.folderList.subFolder.push(this.documentModel);
    console.log('addsubfolderlist', this.folderList);
    this.documentListService.sendUpdatedFolder(this.folderList);
  }

  folderDetails(mainfolder) {
    console.log('folder details', mainfolder);
    this.documentListService.sendDocument(mainfolder);
  }



}
